import { useCacheSlice } from "../hooks";

export type Activity = {
  activityCode: string;
  activity: string;
  activityDescription: string;
  activityGroup: string;
};

export function useActivitiesCache() {
  const { data, isLoading } = useCacheSlice("activities");
  const activities = data as Activity[];
  return { activities, isLoading };
}
